interface ProposalIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const ProposalIcon = (props: ProposalIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <path
          style={{ fill: 'none', stroke: fillColor }}
          d="M26.4,24l0.2-2.6l-0.3-2V8.6c0-0.9-0.7-1.6-1.6-1.6H10.8C9.9,7,9.2,7.7,9.2,8.6v16.5c0,0.9,0.7,1.6,1.6,1.6h13"
        />
        <rect x="24.7" y="31.8" style={{ fill: 'none', stroke: fillColor }} width="6.9" height="2.6" />
        <rect x="25.4" y="30.5" style={{ fill: 'none', stroke: fillColor }} width="5.5" height="1.4" />
        <path style={{ fill: 'none', stroke: fillColor }} d="M30.3,30.5c0,0,0.4-4.6,0.5-6.4c0.1-1.9-2-7.2-4.2-7.2" />
        <path
          style={{ fill: 'none', stroke: fillColor }}
          d="M25.8,30.5c0,0-0.2-0.8-1.1-2.4s-1.1-2.4-0.4-4c0.7-1.5,0.5-4.4,1.1-4.4c0,0,0.3,0,0.7,0.1"
        />
        <path
          style={{ fill: fillColor }}
          d="M19.7,24.1h-8.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h8.1c0.2,0,0.4,0.2,0.4,0.4
        C20.2,24,19.9,24.1,19.7,24.1z"
        />
        <path
          style={{ fill: fillColor }}
          d="M16.3,22.7h-4.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h4.6c0.2,0,0.4,0.2,0.4,0.4
        C16.7,22.5,16.5,22.7,16.3,22.7z"
        />
        <path
          style={{ fill: fillColor }}
          d="M16.3,21.2h-4.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h4.6c0.2,0,0.4,0.2,0.4,0.4
        C16.7,21,16.5,21.2,16.3,21.2z"
        />
        <path
          style={{ fill: fillColor }}
          d="M18.2,9.4v0.8c0.4,0.1,0.7,0.2,1.1,0.3c0.2,0.1,0.3,0.2,0.3,0.5c0,0.2-0.2,0.5-0.5,0.5c-0.2,0-0.2-0.1-0.4-0.1
        c-0.4-0.2-0.7-0.2-1.1-0.2c-0.6,0-1.1,0.3-1.1,0.8s0.2,0.7,0.8,1l1.1,0.5c0.7,0.3,1.4,0.7,1.4,1.9c0,1-0.7,1.6-1.5,1.9V18
        c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5v-0.7c-0.6,0-1.1-0.2-1.5-0.4c-0.2-0.1-0.3-0.2-0.3-0.5c0-0.3,0.2-0.5,0.5-0.5
        c0.2,0,0.2,0,0.4,0.1c0.3,0.2,0.7,0.2,1.2,0.2c0.7,0,1.2-0.3,1.2-0.9c0-0.5-0.3-0.7-0.9-1.1l-1.2-0.6c-0.7-0.3-1.2-0.8-1.2-1.7
        c0-1,0.7-1.6,1.8-1.8V9.4c0-0.3,0.2-0.5,0.5-0.5S18.2,9.1,18.2,9.4z"
        />
      </g>
    </svg>
  )
}

export default ProposalIcon
